import React from 'react';
import { Card, CardBody, CardHeader, Table, Badge, Spinner } from 'reactstrap';
import Icon from 'components/Icon';
import { Link } from 'react-router-dom';

interface RecentItem {
  id: string;
  name: string;
  status?: boolean;
  date?: string;
  extra?: string;
}

interface RecentItemsCardProps {
  title: string;
  icon: string;
  items: RecentItem[];
  viewAllLink: string;
  isLoading?: boolean;
  emptyMessage?: string;
  statusLabels?: { active: string; inactive: string };
}

const RecentItemsCard = ({
  title,
  icon,
  items,
  viewAllLink,
  isLoading = false,
  emptyMessage = 'Nenhum item encontrado',
  statusLabels = { active: 'Ativo', inactive: 'Inativo' }
}: RecentItemsCardProps) => {
  return (
    <Card className="border-0 shadow-sm h-100">
      <CardHeader className="bg-white border-0 pt-4 pb-2 d-flex align-items-center justify-content-between">
        <h5 className="mb-0 fw-bold">
          <Icon icon={icon} className="me-2 text-primary" />
          {title}
        </h5>
        <Link
          to={viewAllLink}
          className="text-primary small text-decoration-none"
        >
          Ver todos <Icon icon="arrow-right" width={14} height={14} />
        </Link>
      </CardHeader>
      <CardBody className="pt-0">
        {isLoading ? (
          <div className="text-center py-4">
            <Spinner color="primary" />
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-4 text-muted">
            <Icon icon="inbox" width={40} height={40} className="mb-2" />
            <p className="mb-0">{emptyMessage}</p>
          </div>
        ) : (
          <Table responsive borderless className="mb-0">
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td className="py-3">
                    <span className="fw-medium">{item.name}</span>
                    {item.extra && (
                      <small className="d-block text-muted">{item.extra}</small>
                    )}
                  </td>
                  <td className="py-3 text-end">
                    {item.status !== undefined && (
                      <Badge
                        color={item.status ? 'success' : 'secondary'}
                        className="rounded-pill"
                      >
                        {item.status
                          ? statusLabels.active
                          : statusLabels.inactive}
                      </Badge>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  );
};

export default RecentItemsCard;
